
import { Observable } from './druid/./druid/Observable';
import { share } from './druid/./druid/operator/share';

Observable.prototype.share = share;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    share: typeof share;
  }
}